var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"loginbox"},[_c('span',{staticClass:"notice-text"},[_vm._v(_vm._s(this.checkNotice))])])])}
var staticRenderFns = []

export { render, staticRenderFns }